import { render, staticRenderFns } from "./CallChargeError.vue?vue&type=template&id=36e52516&"
import script from "./CallChargeError.vue?vue&type=script&lang=js&"
export * from "./CallChargeError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports